module.exports = __webpack_public_path__ + "img/corporate_culture.73f7eef.png";